module.exports = __webpack_public_path__ + "img/Bolttech.b54fb9a5.png";